import { makeStyles } from '@mui/styles';

export default makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
    width: '100%'
  },
  modalLeft: {
    display: 'flex',
    flexDirection: 'column',
    flexBasis: '36%',
    borderRight: '1px solid #F3F3F3'
  },
  modalRight: {
    display: 'flex',
    flexDirection: 'column'
  },
  candidateList: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    overflowY: 'scroll'
  },
  loading: {
    margin: 'auto'
  }
}));
